/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterNumberType extends models.ParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ParameterNumberType");
    }

    getFixupPrototypeFunction() { return ParameterNumberType.fixupPrototype; }

    static newInstance(model: Partial<ParameterNumberType>): ParameterNumberType {
        let obj = Object.assign(new ParameterNumberType(), model);
        ParameterNumberType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterNumberType>): ParameterNumberType {
        if (!model) return null;
        return ParameterNumberType.newInstance(<ParameterNumberType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterNumberType) {
        if (!obj) return;

        models.ParameterNumberType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterNumberType): boolean {
        if (models.ParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterNumberType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.constraints) {
            for (let val of this.constraints) {
                models.ParameterConstraintBaseForNumber.fixupPrototype(val);
            }
        }
    }

    constraints: Array<models.ParameterConstraintBaseForNumber>;

}
